import React, { ReactElement } from 'react';
import { TerminDetail } from 'tezaury-frontend-ts-axios';
import {
  Link, Table, Tbody, Td, Th, Thead, Tr,
} from 'idsk-react-components';
import { useNavigate } from 'react-router';
import { useResponsiveContext } from 'slovlex-idsk-react-components';
import DetailTerminuSectionHeading
  from '../DetailTerminuSectionHeading/DetailTerminuSectionHeading';
import routes from '../../../routing/routes';
import TerminDetailEmptyDataMessage
  from '../TerminDetailEmptyDataMessage/TerminDetailEmptyDataMessage';
import PreviazaneTerminyMobileTableItem from './component/PreviazaneTerminyMobileTableItem';

interface Props {
  termin: TerminDetail;
  admin?: boolean;
}

const DetailTerminuPreviazaneTerminy = ({
  termin,
  admin = false,
}: Props): ReactElement => {
  const navigate = useNavigate();
  const { isSmallScreen } = useResponsiveContext();

  return (
    <>
      {(admin || termin.previazanyTerminList.length > 0) && (
        <div className="detail-previazane-terminy">
          <DetailTerminuSectionHeading
            heading="Previazané termíny"
            admin={admin}
            onClick={() => navigate(routes.tezaurus.admin.termin.edit.previazaneTerminy
              .withParams(termin.tezaurus.uuid, termin.uuid))}
            terminListNotEmpty={termin.previazanyTerminList.length > 0}
          />

          {admin && termin.previazanyTerminList.length === 0 && (
          <TerminDetailEmptyDataMessage text="Termín nemá žiadne previazané termíny." />
          )}

          {isSmallScreen ? (
            <div>
              {termin.previazanyTerminList.map(item => (
                <PreviazaneTerminyMobileTableItem
                  key={`previazanyTerminTableComponentKey-${item.uuid}`}
                  termin={item.nazov}
                  typVztahu={item.vztah}
                  tezaurus={item.tezaurus.nazov}
                  uuid={item.uuid}
                />
              ))}
            </div>
          ) : (
            <div>
              {termin.previazanyTerminList.length > 0 && (
              <Table>
                <Thead>
                  <Tr>
                    <Th>Termín</Th>
                    <Th>Typ vzťahu</Th>
                    <Th>Tezaurus</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {termin.previazanyTerminList.map(previazanyTermin => (
                    <Tr key={previazanyTermin.uuid}>
                      <>
                        <Td>
                          <Link
                            to={routes.tezaurus.detail.withParams(previazanyTermin.uuid)}
                          >
                            {previazanyTermin.nazov}
                          </Link>
                        </Td>
                        <Td>{previazanyTermin.vztah}</Td>
                        <Td>{previazanyTermin.tezaurus.nazov}</Td>
                      </>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default DetailTerminuPreviazaneTerminy;
